import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch, ILazyParams, baseUrl } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { Filter, InvoiceTrackingFilter } from "./Filter";
import { format } from "date-fns";
import { GenerateInvice } from "../subVendorInvoices/GenerateInvice";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { IInvoiceTracking } from "../invoiceTracking/GenerateInvoices";
import { SendEmailForPaymentUpdate } from "./SendEmailForPaymentUpdate";
import { FollowUpEmailHistory } from "./FollowUpEmailHistory";
import { FollowUpCallHistory } from "./FollowUpCallHistory";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { BillingCycle } from "../showPurchaseOrder/GeneratePO";
import { PaymentTerm } from "../../models/ConsultantMast";

export interface InvoiceTracking {
    addedBy?: string,
    client?: string,
    consultant_ID?: number,
    consultant_Name?: string,
    dueDate?: string,
    end_Client?: string,
    fromDate?: string,
    invoiceAmount?: number,
    invoiceHours?: number,
    invoiceNo?: string,
    invoicePath?: string,
    invoice_ID?: number,
    job_Titles?: string,
    mRate?: number,
    pO_ID?: number,
    prime_Vendor_Billing_Cycle?: BillingCycle,
    prime_Vendor_Payment_Term?: PaymentTerm,
    sRate?: number,
    sales?: string,
    start_Date?: string,
    timeSheet_Status1?: string,
    toDate?: string,
    vendor?: string,
    verfiedBy?: number,
    verifiedBy?: string,
    invoiceStatus?: string,
    createdOn?: string,
    verifyComment?: string,
    paymentStatus?: string,
    balance_Rate?: number,
    receivedAmount?: number,
    payment_Mode?: string,
    transaction_ID?: string,
    isInoviceRemitance?: boolean,
    aging?: number,
    credit_Note_Comment?: string,
    releasePaymentDate?: Date,
    releasePaymentType?: number,
    isCalculated?: boolean,
    followUpEmailCount?: number,
};



interface IProps {
    permissions: IPermissionProps,
    toast: any,
    po: IPurchaseOrder,
}

export const EmptyFilter: InvoiceTrackingFilter = {
    year: null,
    month: null,
    vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    prime_Vendor_Billing_Cycle: null,
    invoiceStatus: null,
    paymentStatus: null,
    dueDateFrom: null,
    dueDateTo: null,
    consultant: {
        consultant_ID: 0,
        consultant_Name: ""
    }
}


export const InvoiceTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: InvoiceTracking[], loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [consultantAllInvoices, setConsultantAllInvoices] = useState({ singleData: 0, open: false } as { singleData: number, open: boolean });
    const [generateInvoices, setGenerateInvoices] = useState({ singleData: {}, open: false, action: false } as { singleData: IInvoiceTracking, open: boolean, action: boolean });
    const [selectedInvoices, setSelectedInvoices] = useState<InvoiceTracking[]>();
    const [selectedHotList, setSelectedHotList] = useState<Array<number | undefined>>();
    const [openSendEmail, setOpenSendEmail] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openRemitance, setOpenRemitance] = useState({ singleData: {}, open: false } as { singleData: InvoiceTracking, open: boolean });
    const [openSubvendorModal, setOpenSubvendorModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [isCreditNoteOpen, setIsCreditNoteOpen] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [credit_Note_Comment, setCredit_Note_Comment] = useState("");
    const [openEmailHistory, setOpenEmailHistory] = useState({ singleData: {}, open: false } as { singleData: InvoiceTracking, open: boolean });
    const [openCallHistory, setOpenCallHistory] = useState({ singleData: {}, open: false } as { singleData: InvoiceTracking, open: boolean });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 100,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });




    const consultant_Name = (rowData: InvoiceTracking) => {
        return (
            <>
                <span className={"cursor-pointer underline " + (rowData.paymentStatus === "Pending" ? "text-black" : "text-cyan-700")}>{rowData?.consultant_Name}</span>
            </>
        );
    };

    const onHideCreditNote = () => {
        setIsCreditNoteOpen({ singleData: {}, open: false });
        setCredit_Note_Comment("");
    }

    const credit_Note = (rowData: InvoiceTracking) => {
        return (
            <>
                <span className={rowData.paymentStatus === "Balance" ? "text-black" : "text-white"}>{(rowData.credit_Note_Comment && rowData.credit_Note_Comment !== null && rowData.credit_Note_Comment !== undefined) ? rowData.credit_Note_Comment : ""}</span>
            </>
        );
    };

    useEffect(() => {
        if (isCreditNoteOpen.open) {
            if (isCreditNoteOpen.singleData.credit_Note_Comment != null && isCreditNoteOpen.singleData.credit_Note_Comment.trim() != "") setCredit_Note_Comment(isCreditNoteOpen.singleData.credit_Note_Comment);
        };
    }, [isCreditNoteOpen.open]);

    const getSubvendorInvoiceDetails = async (data: InvoiceTracking) => {
        const response = await Fetch('InvoiceTracking/getSubvendorDetailsByPOID', 'GET', null, `poID=${data.pO_ID}`, null);
        if (response) {
            const respdata: any = await response.json();
            // console.log("---- respdata ----", respdata);
            let svInvoiceData: any = {
                bRate: respdata.bRate,
                consultant_ID: data.consultant_ID,
                consultant_Name: data.consultant_Name,
                dueDate: null,
                fromDate: new Date(data?.fromDate || ""),
                invoiceAmount: null,
                invoiceDate: null,
                invoiceNO: null,
                invoicePath: null,
                pO_ID: data.pO_ID,
                paidAmount: null,
                paymentStatus: null,
                payment_Date: null,
                payment_Mode: null,
                primeVendor_Company_Name: respdata.vendor_Company_Name,
                primevendorInvoice_ID: data.invoice_ID,
                requestedAmount: null,
                toDate: new Date(data?.toDate || ""),
                transaction_ID: null,
                workingHours: data.invoiceHours,
                vendor_Company_ID: respdata.sub_Vendor_ID,
                vendor_Company_Name: respdata.sub_Vendor_Company,
                sub_Vendor_Payment_Term: respdata.sub_Vendor_Payment_Term,
                sub_Vendor_Billing_Cycle: respdata.sub_Vendor_Billing_Cycle,
                project_Start_Date: new Date(respdata.project_Start_Date),
                project_End_Date: new Date(respdata.project_End_Date),
                prime_Vendor_Billing_Cycle: respdata.prime_Vendor_Billing_Cycle,
            };
            // console.log("---- svInvoiceData ----", svInvoiceData);
            setOpenSubvendorModal({ singleData: svInvoiceData, open: true });
        }
    }

    const reCalculateInvoice = (rowData: InvoiceTracking) => {
        confirmDialog({
            message: `Are you sure you want to re-calculate incentive amount"?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => reCalculateIncetiveAmount(rowData),
            reject: () => rejectFunc()
        });
    }

    const deleteInvoice = (rowData: InvoiceTracking) => {
        confirmDialog({
            message: `Are you sure you want this Invoice"?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => deleteInvoiceEndPoint(rowData),
            reject: () => rejectFunc()
        });
    }

    const reCalculateIncetiveAmount = async (rowData: InvoiceTracking) => {
        if (rowData.isCalculated === true) {
            props.toast.current.show({ severity: 'error', detail: "Incentive Calculation Is Hold", life: 3000 });
        } else {
            const response = await Fetch("InvoiceTracking/reCalculateIncetiveAmount", "PUT", null, `invoice_ID=${rowData.invoice_ID}`, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: "Re-Calculated Successfully", life: 3000 });
                loadTableData();
            }
        }
    }

    const deleteInvoiceEndPoint = async (rowData: InvoiceTracking) => {
        const response = await Fetch("InvoiceTracking/deleteInvoiceByID", "DELETE", null, `invoice_ID=${rowData.invoice_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Invoice Deleted Successfully", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => {
        // dialog closed.
    }


    const action = (rowData: InvoiceTracking) => {
        let data = {
            invoice_ID: rowData.invoice_ID,
            paymentStatus: rowData.paymentStatus,
            receivedAmount: rowData.receivedAmount,
            payment_Mode: rowData.payment_Mode,
            transaction_ID: rowData.transaction_ID,
            invoiceAmount: rowData.invoiceAmount,
            releasePaymentType: rowData.releasePaymentType,
            isCalculated: rowData.isCalculated,
        };

        return <div style={{ width: "8rem", display: "flex", justifyContent: "space-between", gap: "3px" }}>
            {rowData.invoice_ID ? <React.Fragment>
                {(_roles.includes(1) || (_roles.includes(42))) && <Button className={(rowData.verifiedBy && rowData.verifiedBy !== null && rowData.verifiedBy !== "") ? "pi pi-pencil text-primary bg-green-300 border-none text-base" : "pi pi-pencil text-primary bg-white border-none text-base"} tooltip="Edit" onClick={() => setGenerateInvoices({ singleData: { ...data, verify: (rowData.verifiedBy && rowData.verifiedBy !== null && rowData.verifiedBy !== "") ? true : false }, open: true, action: false })}></Button>}
            </React.Fragment> : ''}
            {(_roles.includes(43) || _roles.includes(1)) && <Button className={"pi pi-sitemap border-none"} tooltip="Subvendor Inovice" onClick={() => getSubvendorInvoiceDetails(rowData)}></Button>}
            {(_roles.includes(42) || _roles.includes(1)) && <Button className={"pi pi-replay border-none"} tooltip="Re-Calculate Inovice" onClick={() => reCalculateInvoice(rowData)}></Button>}
            {(_roles.includes(42) || _roles.includes(1)) && <Button className={"pi pi-trash border-none"} tooltip="Delete Inovice" onClick={() => deleteInvoice(rowData)}></Button>}
        </div>;
    };


    const hideDialog = () => {
        setGenerateInvoices({ singleData: {}, open: false, action: false });
        setSelectedHotList([]);
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.vendor_Company = invoiceFilter.vendor_Company?.vendor_Company_ID;

        if (invoiceFilter.consultant?.consultant_Name) {
            updateInvoiceFilter.consultantName = invoiceFilter.consultant?.consultant_Name;
        } else updateInvoiceFilter.consultantName = null;

        delete updateInvoiceFilter.consultant;

        let po_id_Query = "";

        const response = await Fetch("InvoiceTracking/getAllPendingPaymentInvoices", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + `&Consultant_ID=${consultantAllInvoices.singleData}` + po_id_Query, props.toast);
        if (response) {
            const data: InvoiceTracking[] = await response.json();
            setTableData({ tableData: data, loading: false });
            //setTotalRecords(2614);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }
    const loadTableDataCount = async () => {
        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.vendor_Company = invoiceFilter.vendor_Company?.vendor_Company_ID;

        let po_id_Query = "";


        const response = await Fetch("InvoiceTracking/getAllPendingPaymentInvoicesCount", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + `&Consultant_ID=${consultantAllInvoices.singleData}` + po_id_Query, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    };

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        //setConsultantAllInvoices({ singleData: 0, open: false });
        loadTableData();
        loadTableDataCount();
    }, [lazyParams, invoiceFilter, consultantAllInvoices]);


    const rightToolbarTemplate = () => {
        return (
            <Button
                label="Send Payment Follow up Email"
                onClick={() => {
                    if (selectedInvoices && selectedInvoices.length > 0) {
                        setOpenSendEmail(true); // Open bulk update modal
                    } else {
                        props.toast.current.show({
                            severity: 'warn',
                            detail: 'Please select at least 1 invoices to send email.',
                            life: 3000,
                        });
                    }
                }}
            />
        );
    };

    const closeSendEmailModal = () => {
        setOpenSendEmail(false);
        setSelectedInvoices([]);
        loadTableData();
    }

    const rowClass = (data: any) => {
        return {
            'bg-blue-200 text-black': data.paymentStatus === "Balance",
            // 'bg-red-400 text-white': data.paymentStatus === "Pending",
        };
    }

    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            {/* <Toolbar className="mb-1 py-0"  ></Toolbar> */}
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={props.po.pO_ID ? true : false} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                selection={selectedInvoices}
                onSelectionChange={(e) => {
                    if (e.value.verfiedBy === null || _roles.includes(1)) {
                        setSelectedInvoices(e.value);
                    }
                }}
                selectionMode="checkbox"
                dataKey="invoice_ID"
                paginator
                rows={100}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                rowClassName={rowClass}
            >
                <Column selectionMode="multiple" />
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Name" body={consultant_Name} />
                <Column field="prime_Vendor_Company" header="Prime Vendor Company" />
                <Column field="invoiceNO" header="Invoice#" />
                {/* <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} /> */}
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="invoiceStatus" header="Inv Status" />
                <Column field="invoiceHours" header="Hours" />
                <Column field="sRate" header="Rate" />
                <Column field="invoiceAmount" header="Amout" />
                {/* <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                <Column field="dueDate" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.dueDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="paymentStatus" header="Payment Status" body={(rowData: InvoiceTracking) => <p className={rowData.isInoviceRemitance === true ? "cursor-pointer text-cyan-700 underline" : ""}>{rowData.paymentStatus}</p>} />
                <Column field="receivedAmount" header="Received Amount" />
                <Column field="aging" header="Aging" />
                <Column field="followUpEmailCount" header="Follow Up Email Count" body={(rowData) => <p className="cursor-pointer underline" onClick={() => setOpenEmailHistory({ singleData: rowData, open: true })}>{rowData.followUpEmailCount}</p>} />
                <Column field="followUpCallCount" header="Follow Up Call Count" body={(rowData) => <p className="cursor-pointer underline" onClick={() => setOpenCallHistory({ singleData: rowData, open: true })}>{rowData.followUpCallCount}</p>} />
            </DataTable>
            {/* <GenerateInvoices open={generateInvoices.open} toast={props.toast} hideDialog={hideDialog} singleData={generateInvoices.singleData} action={generateInvoices.action} loadTableData={loadTableData} loadTableDataCount={loadTableDataCount} po={props.po} /> */}

            <SendEmailForPaymentUpdate tableData={selectedInvoices || []} openSendEmail={openSendEmail} closeSendEmailModal={closeSendEmailModal} toast={props.toast} />
            <FollowUpEmailHistory open={openEmailHistory.open} onClose={() => setOpenEmailHistory({ singleData: {}, open: false })} toast={props.toast} singleDate={openEmailHistory.singleData} />
            <FollowUpCallHistory open={openCallHistory.open} onClose={() => setOpenCallHistory({ singleData: {}, open: false })} toast={props.toast} singleDate={openCallHistory.singleData} />

            <ConfirmDialog />
        </>
    );
}